import React from 'react';
import CustomScrollTrigger from 'js/wrapper/CustomScrollTrigger';
import { Parallax } from 'react-scroll-parallax';
import { useSortable } from '@dnd-kit/sortable';
import { CSS } from '@dnd-kit/utilities';

import { useAbstractCmsElement } from 'components/cms/hooks/useAbstractCmsElementNew';


function CmsElementTimeline(props) {
  const { editMode, index, showElementSettings, children } = props;

  // CMS Logic Hook
  const {
    shown,
    setShown,
    getMainId,
    getCustomId,
    getParamValue,
    getBackgroundStyle,
    elementStyleTag,
    getParallaxData,
    getAppendHtml,
    cssClasses,
    responsiveClasses,
  } = useAbstractCmsElement(props);

  // dnd-kit Sortable Hook
  const { attributes, listeners, setNodeRef, transform, transition, isDragging } = useSortable({
    id: index,
    disabled: !editMode,
  });

  // Styles for Drag & Drop
  const dndStyle = {
    transform: CSS.Translate.toString(transform),
    transition,
    opacity: isDragging ? 0.5 : 1,
    zIndex: isDragging ? 1000 : 'auto',
    position: 'relative',
    width: '100%',
    cursor: editMode ? 'move' : 'default',
  };

  // Logic & Classes
  const isVisible = editMode || shown;
  const shownClass = isVisible ? 'elem-shown' : 'elem-hidden';
  const parallaxData = getParallaxData();

  const innerContent = (
    <div
      id={getMainId()}
      className={`ms-timeline-container timeline-container ${shownClass} ${cssClasses} ${responsiveClasses}`.trim()}
      onClick={(e) => editMode && showElementSettings(e, index)}
      style={getBackgroundStyle()}
    >
      {elementStyleTag}

      {children ? (
        <section className="timeline">{children}</section>
      ) : (
        /* Placeholder falls die Timeline noch leer ist */
        <div className="p-t-30 p-b-30 text-center bg-master-lightest border-dashed">
          <i className="far fa-clock fa-4x hint-text" />
          <p className="m-t-10 small uppercase bold hint-text">Timeline Container</p>
        </div>
      )}

      {getAppendHtml()}
    </div>
  );

  return (
    <div ref={setNodeRef} style={dndStyle} {...attributes} {...listeners}>
      <div>
        <CustomScrollTrigger className="cms-overflow-fix" onEnter={() => setShown(true)} {...getCustomId()}>
          {parallaxData ? (
            <Parallax {...parallaxData}>
              {innerContent}
            </Parallax>
          ) : (
            innerContent
          )}
        </CustomScrollTrigger>
      </div>
    </div>
  );
}

export default CmsElementTimeline;
